export default __webpack_public_path__ + "static/media/social_yellow.png";